import { graphql, useStaticQuery } from 'gatsby';

interface IPlatformData {
  node: {
    version: string;
    _meta: {
      uid: string;
    };
  };
}

const usePlatformVersion = (platform: string) => {
  const { prismic } = useStaticQuery(
    graphql`
      query {
        prismic {
          allChangelogs {
            edges {
              node {
                version
                _meta {
                  uid
                }
              }
            }
          }
        }
      }
    `,
  );

  const platformData = prismic.allChangelogs.edges.filter((log: IPlatformData) => {
    return log.node._meta.uid === platform.toLowerCase();
  });

  return platformData[0].node.version;
};

export default usePlatformVersion;
